export const MANAGERS = ["owner", "admin"];
export const ALL_ROLES = ["owner", "admin", "kasir"];

export const ROLE_LABEL = { owner: "Pemilik", admin: "Admin", kasir: "Kasir" };
export const ROLE_TONE = {
  owner: "bg-emerald-50 text-emerald-700",
  admin: "bg-sky-50 text-sky-700",
  kasir: "bg-amber-50 text-amber-800",
};

export const homeFor = (role) => (role === "kasir" ? "/kasir" : "/");
export const can = (user, roles) => !!user && roles.includes(user.role);

const ROUTE_ROLES = {
  "/": MANAGERS, "/kasir": ALL_ROLES, "/produk": MANAGERS, "/riwayat": ALL_ROLES,
  "/laporan": MANAGERS, "/pengaturan": MANAGERS, "/users": ["owner"],
};

export const destFor = (user, path) => {
  const pathname = (path || "").split("?")[0];
  return path && path.startsWith("/") && can(user, ROUTE_ROLES[pathname] || []) ? path : homeFor(user?.role);
};
